import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalFormatPipe'
})
export class DecimalFormatPipeNP implements PipeTransform {

    transform(val) {
        if (val) {
            val = this.format_number(val);
        }
        return val;
    }

    format_number(number) {
        var numberString = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(number)
        return numberString;
    };

}